import { administrationSiteApi } from "api/immunization";
import { humanise } from "config/immunizationConstants";
import MasterListScreen from "./common/MasterListScreen";
import AdministrationSiteModal from "./AdministrationSiteModal";

const AdministrationSiteList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={administrationSiteApi}
    label="Administration site"
    entityLabel="administration site"
    addLabel="Add Site"
    tag="immunization-administration-site"
    headers={[
      "Name",
      "Code",
      "Body Region",
      "Laterality",
      "Valid Routes",
      "Status",
      "Action",
    ]}
    keys={[
      "name",
      "code",
      "bodyRegion",
      "lateralityLabel",
      "routesLabel",
      "statusChip",
      "action",
    ]}
    displayName={(item) => item.display}
    mapRow={(item) => ({
      lateralityLabel: humanise(item.laterality),
      routesLabel: (item.applicableRouteCodes || []).join(", ") || "Any route",
    })}
    Modal={AdministrationSiteModal}
    searchText={searchText}
  />
);

export default AdministrationSiteList;
